import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ViewportAction } from '@sparefoot/react-core';

import { Link } from 'components/core/Link';
import { Button } from 'components/core/Button';

import './oonFacilityCard.scss';
import { withOnVisibleFacilityHandler } from 'decorators/facility';

export const enhance = withOnVisibleFacilityHandler;

export function OONFacilityCard({
	facility,
	getRef,
	responsive,
	onVisible,
	percentVisible,
}) {
	return (
		<ViewportAction
			onVisible={onVisible}
			percentVisible={percentVisible}
		>
			<div
				className={classnames('oon-facility-card', { responsive })}
				ref={getRef}
			>
				<div className="facility-details">
					<Link
						to={facility.url}
						className="facility-name"
					>
						{facility.name}
					</Link>
					<div className="facility-address">
						{facility.location.city}, {facility.location.state}{' '}
						{facility.location.zip}
					</div>
					<div className="facility-distance">
						{facility.distance} mile
						{facility.distance !== 1 ? 's' : ''} away
					</div>
				</div>
				<div className="facility-units">
					No Unit Information Available
				</div>
				<div className="facility-reserve-button">
					<Button
						primary
						to={facility.url}
					>
						Next
					</Button>
				</div>
			</div>
		</ViewportAction>
	);
}

OONFacilityCard.propTypes = {
	facility: PropTypes.shape({
		id: PropTypes.number,
		url: PropTypes.string,
		name: PropTypes.string,
		distance: PropTypes.number,
		location: PropTypes.object,
	}).isRequired,
	getRef: PropTypes.func,
	responsive: PropTypes.bool,
	onVisible: PropTypes.func.isRequired,
	percentVisible: PropTypes.number,
};

OONFacilityCard.defaultProps = {
	responsive: true,
};

export default enhance(OONFacilityCard);
